<div class="container-column section">
    <section>Drafts</section>
</div>
<div class="card-container card" style="overflow-y: auto;">
    <form [formGroup]="form">
        <table style="margin-bottom: 5px;">
            <tr>
                <td>Project:</td>
                <td>
                    <kendo-dropdownlist class="dropdown" [data]="filteredProjects" textField="projectname"
                        valueField="projectId" [style.width.px]="400" formControlName="project" [filterable]="true"
                        (filterChange)="onProjectFilter($event)" (valueChange)="getObjectsForProjects($event)"
                        [style.height.px]="30" [loading]="loading2">
                    </kendo-dropdownlist>
                </td>
            </tr>
            <tr>
                <td>Order No.:</td>
                <td>
                    <div kendoTooltip [title]="roleDescription"><kendo-dropdownlist class="dropdown"
                            [data]="filteredPortalObjects" textField="name" valueField="id"
                            formControlName="purchaseOrder" [style.width.px]="400" [style.height.px]="30"
                            [filterable]="true" (filterChange)="onOrderFilter($event)" [loading]="loading1"
                            (selectionChange)="selectionChange($event)" (valueChange)="getDraftUploads()">
                        </kendo-dropdownlist></div>
                </td>

                <td>
                    <div style="margin-left: 10px;">Company:</div>
                </td>
                <td> <kendo-textbox class="dropdown" formControlName="companyname" [style.width.px]="400"
                        [style.height.px]="30" [readonly]="true">
                    </kendo-textbox></td>
            </tr>
        </table>
    </form>
    <!-- <kendo-textbox [style.width.px]="width" style="margin-bottom: 5px;" placeholder="Search..."
        (valueChange)="onFilter($event)"></kendo-textbox> -->
    <kendo-grid class="content1" [kendoGridBinding]="drafts" kendoGridSelectBy="uploadId" [(selectedKeys)]="selection"
        [selectable]="{ mode: 'single'}" [sortable]="true" [reorderable]="true" [resizable]="true"
        [columnMenu]="{ filter: true }" [loading]="loading" (excelExport)="onExcelExport($event)">
        <ng-template kendoGridToolbarTemplate>
            <button type="button" class="allbuttons" kendoGridExcelCommand [svgIcon]="svgIcon[1]">
                Export
            </button>
        </ng-template>
        <kendo-grid-column field="uploadId" title="Upload ID" [width]="120"></kendo-grid-column>
        <kendo-grid-column field="status" title="Status" [width]="95">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <span style="background-color: rgb(255, 255, 51, 0.2)" class="whole-cell">
                    {{dataItem.status}}
                </span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="projectName" title="Project Name" [width]="140"></kendo-grid-column>
        <kendo-grid-column field="objectName" title="Order No." [width]="155"></kendo-grid-column>
        <kendo-grid-column field="objectDescription" title="Order Description" [width]="210"></kendo-grid-column>
        <kendo-grid-column field="uploadDate" title="Upload Date" [width]="130"
            format="dd-MMM-yyyy"></kendo-grid-column>
        <kendo-grid-column field="uploadedBy" title="Uploaded By" [width]="135"></kendo-grid-column>

        <kendo-grid-column field="transmittal" title="Transmittal" [width]="125"></kendo-grid-column>


        <kendo-grid-column field="remarks" title="Remarks" [width]="110"></kendo-grid-column>
        <kendo-grid-column field="fileCount" title="File Count" [width]="125"></kendo-grid-column>
        <kendo-grid-column title="Edit Upload" [width]="120">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <span>
                    <button #refreshbutton (click)="editUpload(dataItem)" [disabled]="actionsCondition(dataItem)"
                        kendoButton class="allbuttons" [svgIcon]="svgIcon[2]">
                    </button>
                </span>
                <span>
                    <button (click)="deleteConfirmation(dataItem)" [disabled]="actionsCondition(dataItem)" kendoButton
                        class="allbuttons" [svgIcon]="svgIcon[3]">
                    </button>
                </span>
            </ng-template>
        </kendo-grid-column>
        <ng-template kendoGridNoRecordsTemplate>
            <div style="height: 313px;background-color: rgb(215 212 212 / 20%);">
                <kendo-svgicon [icon]="svgIcon[0]" size="xxxlarge"></kendo-svgicon>
                <p>There is no data to display here.
                </p>
            </div>
        </ng-template>
        <kendo-grid-excel [fileName]="getFileName()"></kendo-grid-excel>
    </kendo-grid>
</div>
<div>
    <kendo-dialog *ngIf="showConfirmDialog" title="Delete Draft" (click)="closeDialog()" [width]="'380px'"  
        [height]="'190px'">
        <p>{{ deleteConfirmationMessage }}</p>
        <kendo-dialog-actions>
            <button kendoButton class="allbuttons" (click)="deleteUpload()">Yes</button>
            <button kendoButton class="allbuttons" (click)="closeDialog()">No</button>
        </kendo-dialog-actions>
    </kendo-dialog>
</div>